var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockThree = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.333A6.674 6.674 0 0 0 1.333 8 6.674 6.674 0 0 0 8 14.667 6.674 6.674 0 0 0 14.666 8 6.674 6.674 0 0 0 8 1.333m2.222 7.223H8A.555.555 0 0 1 7.444 8V4.667a.555.555 0 1 1 1.111 0v2.777h1.667a.555.555 0 1 1 0 1.112"
})));
export { SvgClockThree as ReactComponent };
export default __webpack_public_path__ + "0adc2d8944b62e3f0410ad3a64b21b54.svg";